import React from "react";
// types
import { TMainPageLayoutV2 } from "../type";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import MNPGV2 from "@/components/MainPageLayouts/components/MNPGV2";
// hooks
import useContent from "@/hooks/useContent";
// utilities
import { 
    outerTextLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import EContentType from "@/cms/enums/EContentType";
// interfaces
import TClientContentDetail from "@/cms/types/TClientContentDetail";
import TClientPageDetail from "@/cms/types/TClientPageDetail";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";


type TMNPG022 = {
    contentDetails:TClientContentDetail|TClientPageDetail|null;
}

const Render = ( props:{ contentDetails:TClientContentDetail|TClientPageDetail|null, template:TClientMainPageItemList, templates:TClientMainPageItemList[] } ) => {
    if ( !props.contentDetails ) return null;

    const outerLanguageVersion = outerTextLanguageVersion(props.contentDetails.languageVersions, "find", undefined, EContentType.MAIN_PAGE_ITEM);
    
    return (
        <section className="bg-dark pt-100 pb-70" id="saas-about">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div
                            className="saas-about-image"
                            data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-anchor="#saas-about"
                        >
                            <RMDRImage 
                                resources={props.contentDetails.resources}
                                resourceType={EResourceType.OUTER_IMAGE}
                                alt={outerLanguageVersion?.name}
                                title={outerLanguageVersion?.name}
                            />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="saas-about-content white-color">
                            <h2>
                                {outerLanguageVersion?.name}
                            </h2>
                            <RMDRComponentSanitizer variant="div" valueExpr="value" languageVersion={outerLanguageVersion} />
                            {
                                props.template.hasDestinationNavigation && (
                                    <MNPGV2
                                        templates={props.templates} 
                                        mapLayoutName={props.template.mapLayoutName} 
                                        parentId={props.template.id} 
                                        allowedComponent={['MNPG_024']}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

const RenderOwnContent = ( props:{unqKey:string, contentId:string, template:TClientMainPageItemList, templates:TClientMainPageItemList[]} ) => {
    
    const contentDetails = useContent({unqKey:`${props.unqKey}CD`, id:props.contentId});
    return <Render contentDetails={contentDetails} template={props.template} templates={props.templates} />

}

const MNPG022 = ( props: TMainPageLayoutV2<TMNPG022> ) => {
    console.log("MNPG022.rendered", props);

    if ( props.contentDetails && props.template && props.templates ) {
        return <Render contentDetails={props.contentDetails} template={props.template} templates={props.templates} />
    }
    else if ( props.template && props.templates ) {
        const unqKey = props.template.id.split("-")[4];
        return <RenderOwnContent unqKey={unqKey} contentId={props.template.contentId} template={props.template} templates={props.templates} />
    }

    return null;
}

const Component = React.memo(MNPG022, ( prevProps:TMainPageLayoutV2<TMNPG022>, nextProps:TMainPageLayoutV2<TMNPG022> ) => {
    console.log("MNPG022.memo", { prevProps, nextProps });
    return true;
});

export default Component;
